// extracted by mini-css-extract-plugin
module.exports = {"Container":"PixelMixer_Container__3TutL","Content":"PixelMixer_Content__3F5HD","tryCute":"PixelMixer_tryCute__22Vba","ChampName":"PixelMixer_ChampName__37c2m"};